// extracted by mini-css-extract-plugin
module.exports = {"cameraBlock":"uHBr-","photo":"i3VWZ","secondaryButton":"IO8df","hidden":"-Zm4K"};